/** Turn Perplexity's [1]/[2] bracket markers into markdown links using a citations list
 * (1-indexed: [1] -> citations[0]). Shared by the finalized MessageBubble and the live
 * StreamingMessage so links can go live progressively instead of snapping in all at once
 * only once the citations list is fully known (SGL-101). */
export function injectCitationLinks(content: string, citations: string[] | undefined): string {
  if (!citations || citations.length === 0) return content;
  return content.replace(/\[(\d+)\](?!\()/g, (match, numStr) => {
    const idx = parseInt(numStr, 10) - 1;
    if (idx >= 0 && idx < citations.length) {
      return `[${numStr}](${citations[idx]})`;
    }
    return match;
  });
}
